/** Map common MIME types when the File has no name suffix */
export function extensionFromMime(type) {
  if (!type || typeof type !== 'string') return '';
  const base = type.split(';')[0].trim().toLowerCase();
  const map = {
    'video/mp4': '.mp4',
    'video/quicktime': '.mov',
    'video/webm': '.webm',
    'video/x-matroska': '.mkv',
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'image/gif': '.gif',
    'image/webp': '.webp',
    'image/svg+xml': '.svg',
    'image/bmp': '.bmp',
    'audio/mpeg': '.mp3',
    'audio/mp3': '.mp3',
    'audio/wav': '.wav',
    'audio/x-wav': '.wav',
    'audio/webm': '.webm',
    'audio/mp4': '.m4a',
    'audio/x-m4a': '.m4a',
    'audio/aac': '.aac',
    'audio/ogg': '.ogg',
    'application/pdf': '.pdf',
    'text/plain': '.txt',
    'text/csv': '.csv',
    'text/markdown': '.md',
    'application/msword': '.doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
    'application/vnd.ms-excel': '.xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
    'application/vnd.ms-powerpoint': '.ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
    'application/rtf': '.rtf',
    'application/json': '.json',
    'application/xml': '.xml',
    'text/xml': '.xml',
    'application/zip': '.zip',
    'application/x-zip-compressed': '.zip',
  };
  return map[base] || '';
}

export function hasReasonableFilenameExtension(name) {
  const n = String(name || '').trim();
  const i = n.lastIndexOf('.');
  if (i <= 0 || i === n.length - 1) return false;
  const ext = n.slice(i + 1);
  return ext.length >= 1 && ext.length <= 32 && /^[a-z0-9._-]+$/i.test(ext);
}

/** Ensure backend receives a filename with extension when the picker omits it. */
export function normalizeUploadFile(file) {
  if (!file) return file;
  const name = typeof file.name === 'string' ? file.name.trim() : '';
  if (hasReasonableFilenameExtension(name)) return file;
  const ext = extensionFromMime(file.type);
  if (!ext) return file;
  const base = name.replace(/\.+$/, '') || `upload-${Date.now()}`;
  try {
    return new File([file], `${base}${ext}`, {
      type: file.type || 'application/octet-stream',
      lastModified: file.lastModified,
    });
  } catch {
    return file;
  }
}

export function plainTextFromHtml(html) {
  if (typeof html !== 'string' || !html.trim()) return '';
  const d = typeof document !== 'undefined' ? document.createElement('div') : null;
  if (!d) return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  d.innerHTML = html;
  return (d.textContent || '').trim();
}

export function hasReadableRichText(html) {
  return plainTextFromHtml(html).length > 0;
}
